import { apiFetch } from './client';

export interface JobRun {
  id: string;
  jobName: string;
  partnerId: string | null;
  direction: 'outbound' | 'inbound';
  status: 'running' | 'success' | 'failed';
  startedAt: string;
  finishedAt: string | null;
  filesProcessed: number;
  bytes: number;
  error: string | null;
  githubRunUrl: string | null;
  details: Record<string, unknown>;
}

export interface JobRunListResponse {
  runs: JobRun[];
  total: number;
}

export interface JobRunFilters {
  partnerId?: string;
  status?: string;
  page?: number;
  limit?: number;
}

const buildQuery = (params: Record<string, string | number | boolean | undefined>): string => {
  const query = new URLSearchParams();
  for (const [key, value] of Object.entries(params)) {
    if (value !== undefined) query.set(key, String(value));
  }
  const qs = query.toString();
  return qs ? `?${qs}` : '';
};

export const jobsApi = {
  // The Jobs/Activity tabs are read-only over job_runs — job runs are only
  // ever created by onering-crons calling POST /api/transfers/run directly,
  // never from the portal UI.
  listRuns: (filters: JobRunFilters = {}): Promise<JobRunListResponse> => {
    const qs = buildQuery(filters as Record<string, string | number | boolean | undefined>);
    return apiFetch<JobRunListResponse>(`/transfers/runs${qs}`);
  },

  getRun: (id: string): Promise<JobRun> => {
    return apiFetch<JobRun>(`/transfers/runs/${id}`);
  },
};
